var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFE7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9017 10.0456C21.5558 9.69975 20.9971 9.69975 20.6513 10.0456L16.3149 14.3731L11.9785 10.0367C11.6327 9.69088 11.074 9.69088 10.7281 10.0367C10.3823 10.3826 10.3823 10.9413 10.7281 11.2871L15.0645 15.6235L10.7281 19.9599C10.3823 20.3057 10.3823 20.8644 10.7281 21.2103C11.074 21.5561 11.6327 21.5561 11.9785 21.2103L16.3149 16.8739L20.6513 21.2103C20.9971 21.5561 21.5558 21.5561 21.9017 21.2103C22.2475 20.8644 22.2475 20.3057 21.9017 19.9599L17.5653 15.6235L21.9017 11.2871C22.2387 10.9501 22.2387 10.3826 21.9017 10.0456Z",
    fill: "#D43939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d000431705e101042962f33bf54770d6.svg";
export { ForwardRef as ReactComponent };